/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * ガス作業委託情報
 */
export interface Sgkb575aResGasWorkConsignInfo {
    /** 
     * 作業予定日付：日付YYYYMMDD
     */
    workScddt?: string;
    /** 
     * 作業予定時間帯区分コード：半角英数混在
     */
    workTimezkbnCode?: string;
    /** 
     * 作業予定時間帯区分コード名称：全角半角混在
     */
    scheduledworktimezoneDivcdAname?: string;
    /** 
     * 作業希望日（第１希望）：日付YYYYMMDD
     */
    preferredworkdateFirstpreference?: string;
    /** 
     * 作業希望時間帯区分コード（第１希望）：半角英数混在
     */
    preferredworktimezoneDivcdFirstpreference?: string;
    /** 
     * 作業希望時間帯区分コード（第１希望）名称：全角半角混在
     */
    preferredworktimezonedivisioncodeFirstpreferenceAname?: string;
    /** 
     * 作業希望日（第２希望）：日付YYYYMMDD
     */
    preferredworkdateSecondpreference?: string;
    /** 
     * 作業希望時間帯区分コード（第２希望）：半角英数混在
     */
    preferredworktimezoneDivcdSecondpreference?: string;
    /** 
     * 作業希望時間帯区分コード（第２希望）名称：全角半角混在
     */
    preferredworktimezonedivisioncodeSecondpreferenceAname?: string;
    /** 
     * 作業希望日（第３希望）：日付YYYYMMDD
     */
    preferredworkdateThirdpreference?: string;
    /** 
     * 作業希望時間帯区分コード（第３希望）：半角英数混在
     */
    preferredworktimezoneDivcdThirdpreference?: string;
    /** 
     * 作業希望時間帯区分コード（第３希望）名称：全角半角混在
     */
    preferredworktimezonedivisioncodeThirdpreferenceAname?: string;
    /** 
     * 持込機器有料取付フラグ：半角英数混在
     */
    customerownedequipmentNotfreeInstallationflag?: string;
    /** 
     * 持込機器有料取付フラグ名称：全角半角混在
     */
    customerownedequipmentNotfreeInstallationflagAname?: string;
    /** 
     * 持込機器無料取付フラグ：半角英数混在
     */
    customerownedequipmentFreeInstallationflag?: string;
    /** 
     * 持込機器無料取付フラグ名称：全角半角混在
     */
    customerownedequipmentFreeInstallationflagAname?: string;
    /** 
     * 取外機器有料取外フラグ：半角英数混在
     */
    removedequipmentNotfreeFlg?: string;
    /** 
     * 取外機器有料取外フラグ名称：全角半角混在
     */
    removedequipmentNotfreeAname?: string;
    /** 
     * 取外機器無料取外フラグ：半角英数混在
     */
    removedequipmentFreeFlg?: string;
    /** 
     * 取外機器無料取外フラグ名称：全角半角混在
     */
    removedequipmentFreeAname?: string;
    /** 
     * 機器改造有無フラグ：半角英数混在
     */
    kikimodificationEonflg?: string;
    /** 
     * 機器改造有無フラグ名称：全角半角混在
     */
    kikimodificationEonflgAname?: string;
    /** 
     * 開栓種別コード：半角英数混在
     */
    turnonClscode?: string;
    /** 
     * 開栓種別コード名称：全角半角混在
     */
    turnonclsfyAname?: string;
    /** 
     * 作業拠点コード：半角英数混在
     */
    workBasecode?: string;
}
